module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.e30896f3.eot";